"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _actions = require("../actions");

var _store = require("../store");

var _package = require("../../package.json"); // import app components


var Dashboard = function Dashboard() {
  var _sites$siteID, _sites$siteID$deploym, _sites$siteID3, _sites$siteID3$deploy;

  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      config = _ref2$.config,
      _ref2$$cmsState = _ref2$.cmsState,
      sites = _ref2$$cmsState.sites,
      siteID = _ref2$$cmsState.siteID,
      dispatch = _ref2[1];

  var _ref3 = (0, _react.useState)(null),
      _ref4 = _slicedToArray(_ref3, 2),
      changes = _ref4[0],
      setChanges = _ref4[1];

  var lastBuild = sites === null || sites === void 0 ? void 0 : (_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : (_sites$siteID$deploym = _sites$siteID.deployment) === null || _sites$siteID$deploym === void 0 ? void 0 : _sites$siteID$deploym.lastBuild;
  (0, _react.useEffect)(function () {
    var getUnpublishedChanges = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _actions.siteActions.getUnpublishedChanges({
                  siteID: siteID
                }, dispatch, config);

              case 2:
                result = _context.sent;

                if (result) {
                  setChanges(result);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getUnpublishedChanges() {
        return _ref5.apply(this, arguments);
      };
    }();

    getUnpublishedChanges();
  }, [lastBuild]);

  var handleDeploy = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _sites$siteID2, _sites$siteID2$deploy;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _actions.siteActions.deploySite({
                id: siteID
              }, dispatch, config);

            case 2:
              if (sites !== null && sites !== void 0 && (_sites$siteID2 = sites[siteID]) !== null && _sites$siteID2 !== void 0 && (_sites$siteID2$deploy = _sites$siteID2.deployment) !== null && _sites$siteID2$deploy !== void 0 && _sites$siteID2$deploy.badgeImage) {
                dispatch({
                  type: 'SET_DEPLOYMENT_IMAGE',
                  payload: "".concat(sites[siteID].deployment.badgeImage, "?v=").concat(Math.floor(Math.random() * Math.floor(100)))
                });
              }

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDeploy() {
      return _ref6.apply(this, arguments);
    };
  }();

  var deploymentButton = sites !== null && sites !== void 0 && (_sites$siteID3 = sites[siteID]) !== null && _sites$siteID3 !== void 0 && (_sites$siteID3$deploy = _sites$siteID3.deployment) !== null && _sites$siteID3$deploy !== void 0 && _sites$siteID3$deploy.buildHook ? [/*#__PURE__*/_react.default.createElement(_antd.Button, {
    key: "deploy",
    type: "primary",
    onClick: handleDeploy,
    children: "Deploy Website"
  })] : null;
  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    pageTitle: "Dashboard"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 40
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Unpublished changes",
    extra: deploymentButton
  }, changes === null ? /*#__PURE__*/_react.default.createElement(_antd.Skeleton, {
    paragraph: {
      rows: 4
    },
    active: true
  }) : changes !== null && changes !== void 0 && changes.length ? /*#__PURE__*/_react.default.createElement(_antd.List, {
    dataSource: changes,
    renderItem: function renderItem(o) {
      return /*#__PURE__*/_react.default.createElement(_antd.List.Item, {
        actions: [/*#__PURE__*/_react.default.createElement("span", {
          key: "type"
        }, o.actionType)]
      }, /*#__PURE__*/_react.default.createElement(_antd.List.Item.Meta, {
        title: o.title,
        description: o.description
      }));
    }
  }) : /*#__PURE__*/_react.default.createElement(_antd.Empty, {
    description: 'No changes'
  })), /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
    type: "secondary"
  }, "Version: ", _package.version)));
};

var _default = Dashboard;
exports.default = _default;